import {
  Flex,
  Table,
  TableCaption,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { BLUEMONEDDBUTTONS, WHITE } from "../../../../constants/colors";
import moment from "moment";
import { simplifiedExtract } from "../../../../interfaces/defaultInterfaces";
import { useEffect, useState } from "react";
import { ToLocaleFormat } from "../../../../defaultFunctions/formaters";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function TableSalesCredit({ data, title }: any) {
  const [salesCredit, setSalesCredit] = useState(Array<simplifiedExtract>);
  useEffect(() => {
    setSalesCredit(data);
  }, [data]);
  const colors = useRecoilState(customColors)[0];

  // Colunas da ponte entre as duas pontas do split (casadas por idChavesUnicas).
  // A API preenche so um dos dois campos, conforme a tela:
  //   extrato SPLIT   -> valorExtratoPrincipal (quanto ficou no principal)
  //   extrato NORMAL  -> valorExtratoSplit     (quanto foi splitado)
  // Cliente sem split nao recebe nenhum dos dois e as colunas nao aparecem.
  const temPrincipal = salesCredit.some((i) => i.valorExtratoPrincipal != null);
  const temSplit = salesCredit.some((i) => i.valorExtratoSplit != null);
  const temPonte = temPrincipal || temSplit;
  const tituloPonte = temPrincipal ? "No Extrato Principal" : "No Extrato Split";

  // percentualExtratoAtual e sempre o % que FICA no principal: a legenda
  // inverte quando estamos olhando a partir do extrato normal.
  const legendaPct = (pct: number) =>
    temPrincipal
      ? `${Number(pct).toFixed(0)}% no principal`
      : `${(100 - Number(pct)).toFixed(0)}% splitado`;

  return (
    <>
      {salesCredit.length && (
        <Flex w={"100%"} flexDirection={"column"} mt={4}>
          <Text m={4} fontSize={"16px"} fontWeight={"bold"}>
            {title}
          </Text>
          <Table variant={"striped"}>
            <TableCaption fontWeight={"bold"}>
              Total:{" "}
              {ToLocaleFormat(salesCredit.reduce((acc, i) => acc + i.valor, 0))}
            </TableCaption>
            <Thead
              h="60px"
              position="sticky"
              top="0"
              bgColor={colors.BLUEMONEDDBUTTONS}
            >
              <Tr>
                <Th
                  borderRadius={"8px 0 0 8px"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  Data da Venda
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Data do Pagamento
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Id da Transação
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Bandeira
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  N° da Parcela
                </Th>
                {data[0]?.tipoLancamento.lancamento === "Chargeback" ||
                data[0]?.tipoLancamento.lancamento === "Venda Disputa" ? (
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data do Movimento
                  </Th>
                ) : (
                  <></>
                )}
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Valor da Transação
                </Th>
                <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                  Taxa
                </Th>
                {/* <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>Tarifa</Th> */}
                <Th
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                  borderRadius={temPonte ? "0" : "0 8px 8px 0"}
                >
                  Valor Líquido
                </Th>
                {temPonte ? (
                  <>
                    <Th
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                    >
                      {tituloPonte}
                    </Th>
                    <Th
                      borderRadius={"0 8px 8px 0"}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                    >
                      Líquido Total
                    </Th>
                  </>
                ) : (
                  <></>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {salesCredit &&
                salesCredit.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td borderRadius={"8px 0 0 8px"}>
                        {moment(item?.transacao?.dataCriacao).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      </Td>
                      {/* <Td>
                        {moment(item?.transacao?.dataPagamento).format(
                          "DD/MM/YYYY"
                        )}
                      </Td> */}
                      <Td>
                        {item.parcela
                          ? moment(item?.dataLancamento).format("DD/MM/YYYY")
                          : moment(item?.transacao?.dataPagamento).format(
                              "DD/MM/YYYY"
                            )}
                      </Td>
                      <Td>{item?.transacao?.idTransacao}</Td>
                      <Td>{item?.transacao?.bandeira?.bandeira}</Td>
                      {/* <Td>{item?.nroParcelas ? item?.nroParcelas : 1}</Td> */}
                      <Td fontSize="12px">
                        {item.parcela
                          ? `${item.parcela}/${item.nroParcelas}`
                          : ``}
                      </Td>
                      {data[0]?.tipoLancamento.lancamento === "Chargeback" ||
                      data[0]?.tipoLancamento.lancamento === "Venda Disputa" ? (
                        <Td>
                          {moment(item.dataLancamento).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </Td>
                      ) : (
                        <></>
                      )}
                      <Td>
                        {item.nroParcelas > 1 && item.parcela !== null
                          ? ToLocaleFormat(
                              item.transacao.valor / item.nroParcelas
                            )
                          : ToLocaleFormat(item?.transacao?.valor)}
                      </Td>
                      <Td>
                        {item.nroParcelas > 1 && item.parcela !== null
                          ? ToLocaleFormat(
                              item.transacao.taxaCliente / item.nroParcelas
                            )
                          : ToLocaleFormat(item?.transacao?.taxaCliente)}
                      </Td>
                      <Td>{ToLocaleFormat(item?.valor)}</Td>
                      {temPonte ? (
                        <>
                          <Td>
                            {(item.valorExtratoPrincipal ??
                              item.valorExtratoSplit) != null ? (
                              <>
                                {ToLocaleFormat(
                                  (item.valorExtratoPrincipal ??
                                    item.valorExtratoSplit) as number
                                )}
                                {item.percentualExtratoAtual != null ? (
                                  <Text fontSize={"0.7rem"} color={"gray.500"}>
                                    {legendaPct(item.percentualExtratoAtual)}
                                  </Text>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              "—"
                            )}
                          </Td>
                          <Td>
                            {item.valorLiquidoTotal != null
                              ? ToLocaleFormat(item.valorLiquidoTotal)
                              : "—"}
                          </Td>
                        </>
                      ) : (
                        <></>
                      )}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </Flex>
      )}
    </>
  );
}
